import { Component } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CommunicationService} from '../../../services/communication.service';
import {PermissionsService} from '../../../services/permissions.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MagicInsightsService} from '../../../services/magic-insights';
import { Router } from '@angular/router';

@Component({
  selector: 'manage-module',
  standalone: false,
  templateUrl: './manage-module.component.html',
  styleUrl: './manage-module.component.css'
})
export class ManageModuleComponent {

  readonly MODEL_KEY = 'organisation_aira_module';

  dropDownSelectedModuleId: any;
  isSuperuser = false;
  moduleId: any;
  availableModules: any = null;
  moduleDetails: any;
  organisationUsers = [];
  organisationTeams = [];

  constructor(
    private route: ActivatedRoute,
    private communicationService: CommunicationService,
    private permissionsService: PermissionsService,
    private snackbar: MatSnackBar,
    private magicInsightsService: MagicInsightsService,
    private router: Router
  ) {}

  ngOnInit() {
    this.moduleId = this.route.snapshot.queryParamMap.get('id');

    this.magicInsightsService.getMagicInsightsAvailableModules().subscribe(allMods => {
        this.availableModules = allMods;
        if (!this.moduleId){
            if (this.availableModules?.length){
              this.moduleId = this.availableModules[0].id;
            }
        }
        if (this.moduleId){
            this.dropDownSelectedModuleId = this.moduleId
            this.magicInsightsService.getMagicInsightsModuleInfo(this.moduleId).subscribe(indMod => {
                this.moduleDetails = indMod;
                this.communicationService.getIsSuperUserMessage().subscribe(isSuperuser => {
                this.isSuperuser = isSuperuser;
                  if (this.isSuperuser && this.moduleDetails?.perms_access) {
                      this.permissionsService
                        .getSuperuserTeamsAndUsers()
                        .subscribe(data => {
                          this.organisationTeams = data.organisation_teams;
                          this.organisationUsers = data.organisation_users;
                        });
                  }
                })
            });
        }
    });
  }


  onModuleChange() {
    if (this.dropDownSelectedModuleId !== this.moduleId){
      this.moduleId = this.dropDownSelectedModuleId;
      this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { id: this.moduleId },
          queryParamsHandling: 'merge', // Keep other existing params
        });
      this.magicInsightsService.getMagicInsightsModuleInfo(this.moduleId).subscribe(indMod => {
          this.moduleDetails = indMod;
      });
    }
  }


  onPermissionChanged(event: any) {
    this.snackbar.open('Permissions updated')
  }



}
